import axios from 'axios';
import { baseUrl, HttpMethods } from '../base';
import type { IGetAuditsService, IGetAuditsServiceRes } from './types';

export async function getAudits({ params }: IGetAuditsService): Promise<IGetAuditsServiceRes> {
  const res = await axios.request<IGetAuditsServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/audits`,
    params,
  });
  return res.data;
}
